import React from "react";
import { Grid, Typography } from "@material-ui/core";
import profileImage from "../../../assets/img/crm/profile_image.png";
import { CustomBox } from "components/Box/CustomBox";
import { grey } from "@material-ui/core/colors";
import { useDispatch, useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import RegularButton from "components/CustomButtons/Button";
import { editCustomerMode } from "redux/actions/customers/customersAction";

export const CustomerInfo = () => {
  const { customer } = useSelector(({ customersReducer }) => customersReducer);
  const { rules } = useSelector(({ login }) => login);
  const { isDark } = useThemeMode();
  const color = isDark ? grey[300] : grey[900];
  const isActive = rules.includes('CUSTOMER-CLIENT')
  const dispatch = useDispatch();
  const editable = customer?.isCredit === 1
  const handleView = () => {
    dispatch(editCustomerMode(true));
  };
  
  return (
    <CustomBox >
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={9}>
          <Typography variant="caption" color="primary" component="p">
            No: <span style={{ color: color }}>{customer?.code}</span>
          </Typography>
          <Typography variant="caption" color="primary" component="p">
            Dirección:{" "}
            <span style={{ color: color }}>{customer?.fullAddress}</span>
          </Typography>
          <Typography variant="caption" color="primary" component="p">
            Telefono: <span style={{ color: color }}>{customer?.phone}</span>
          </Typography>
          <Typography variant="caption" color="primary" component="p">
            RFC: <span style={{ color: color }}>{customer?.rfc}</span>
          </Typography>
          {
            customer?.isWholesaler ? (
              <Typography variant="caption" color="primary" component="p">
                <span style={{ fontWeight: 600 }}>CLIENTE MAYORISTA</span>
              </Typography>
            ) : ''
          }
        </Grid>
        <Grid item xs={12} sm={3}>
          <figure
            style={{
              width: 60,
              height: 60,
              margin: "12px auto",
              position: "relative",
            }}
          >
            <img
              src={profileImage}
              alt="profile 1"
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                position: "absolute",
                left: 0,
                zIndex: 0,
                filter: "blur(20px)",
              }}
            />
            <img
              src={profileImage}
              alt="Profile 2"
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                position: "absolute",
                left: 0,
                zIndex: 1,
              }}
            />
          </figure>
        </Grid>
      </Grid>
      {
        isActive &&
      <RegularButton fullWidth color="info" size="sm" onClick={handleView} disabled={editable}>
        Editar Cliente
      </RegularButton>
      }
    </CustomBox>
  );
};
